// extracted by mini-css-extract-plugin
export default {"root":"PriceText-root_lJT6S"};